// This file was automatically generated from render.homeReqActFeedItem.html.
// Please don't edit this file by hand.

goog.provide('el8.template.render.homeReqActFeedItem');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.appchart.letters.unreadAlertNotification');
goog.require('el8.template.button');
goog.require('el8.template.ptdata.letterReceipts');
goog.require('el8.template.ptdata.letters');
goog.require('el8.template.ptdata.model.order');
goog.require('el8.template.ptdata.patients');
goog.require('el8.template.ptdata.plrCollaboratorNotifications');
goog.require('el8.template.ptdata.reports');
goog.require('el8.template.render.chartFeedItem');
goog.require('el8.template.render.messageThreadContent');
goog.require('el8.template.render.signOff');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.homeReqActFeedItem.reqActPatient = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItem ', (opt_data.feedName == 'messages' || opt_data.feedName == 'urgents' || opt_data.feedName == 'providerLetters' || opt_data.feedName == 'patientLetters') ? 'el8NoMarginItem' : 'el8FeedItemHover', '"><div class="el8FeedItemDate">');
  if (! (opt_data.feedName == 'providerLetters' && el8Globals.PASSPORT_EMR)) {
    el8.template.render.chartFeedItem.feedDate({feedDate: opt_data.patient.feedDate}, output);
  }
  output.append((opt_data.feedName == 'messages') ? '' : (opt_data.feedName == 'rxRequests') ? '<div class="el8FeedItemIconRx"></div>' : (opt_data.feedName == 'reports') ? '<div class="el8FeedItemIconReport"></div>' : (opt_data.feedName == 'unfinishedNotes') ? '<div class="el8FeedItemIconNote"></div>' : (opt_data.feedName == 'unfinishedLetters') ? '<div class="el8FeedItemIconLetter"></div>' : (opt_data.feedName == 'unfinishedOrders') ? '<div class="el8FeedItemIconOrder"></div>' : '', '</div><div class="el8FeedItemContainer">', (opt_data.feedName == 'reports' && opt_data.isSelfQueue && ! opt_data.isSinglePhysicianPractice) ? '<div class="el8FeedItemActionContainer"><button class="el8FeedButton el8AloneButton assign-report-trigger ebs-btn ebs-btn-default" data-patient-id="' + soy.$$escapeHtml(opt_data.patient.id) + '">Re-assign</button></div>' : '');
  if (opt_data.patient.tags) {
    output.append('<ol class="ebs-list-inline"><li class="el8InlineItem el8TagWrap"><p>', (! opt_data.patient.isVerified) ? '<span class="el8NewChartItem">New</span>' : '', (opt_data.patient.isVip) ? '<span class="el8VipTag mr5">VIP</span>' : '', '<a class="launch-patient-trigger" data-id="', soy.$$escapeHtml(opt_data.patient.id), '">', soy.$$escapeHtml(opt_data.patient.name), '</a><span class="el8Indent el8AppColor">(', soy.$$escapeHtml(opt_data.patient.sex), ')</span><span class="el8Indent el8AppColor">D.O.B.: ', soy.$$escapeHtml(opt_data.patient.dob), ' (', soy.$$escapeHtml(opt_data.patient.displayAge), ')</span></p></li>');
    var tList28367 = opt_data.patient.tags;
    var tListLen28367 = tList28367.length;
    for (var tIndex28367 = 0; tIndex28367 < tListLen28367; tIndex28367++) {
      var tData28367 = tList28367[tIndex28367];
      el8.template.ptdata.patients.tag({tag: tData28367}, output);
    }
    output.append('</ol>');
  } else {
    output.append('<p>', (! opt_data.patient.isVerified) ? '<span class="el8NewChartItem">New</span>' : '', '<a class="launch-patient-trigger" data-id="', soy.$$escapeHtml(opt_data.patient.id), '">', soy.$$escapeHtml(opt_data.patient.name), '</a><span class="el8Indent el8AppColor">(', soy.$$escapeHtml(opt_data.patient.sex), ')</span><span class="el8Indent el8AppColor">D.O.B.: ', soy.$$escapeHtml(opt_data.patient.dob), ' (', soy.$$escapeHtml(opt_data.patient.displayAge), ')</span></p>');
  }
  output.append((opt_data.patient.phone || opt_data.patient.lastSeenDate || opt_data.patient.nextApptDate) ? '<p class="el8AppColor">' + ((opt_data.patient.phone) ? '<span class="el8RightIndent">Phone: ' + soy.$$escapeHtml(opt_data.patient.phone) + '</span>' : '') + ((opt_data.patient.lastSeenDate) ? '<span class="el8Indent">Last seen: ' + (soy.$$escapeHtml(opt_data.patient.lastSeenDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.patient.lastSeenDate)) : '') + '</span>' : '') + ((opt_data.patient.nextApptDate) ? '<span class="el8Indent">Next appt: ' + (soy.$$escapeHtml(opt_data.patient.nextApptDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.patient.nextApptDate)) : '') + '</span>' : '') + '</p>' : '', '<p class="el8AppColor">');
  el8.template.render.homeReqActFeedItem.summary({feedName: opt_data.feedName, modelCounts: opt_data.patient.modelCounts, vip: opt_data.patient.isVip}, output);
  output.append('</p>');
  if (! opt_data.patient.isVip) {
    if (opt_data.feedName == 'reports' || opt_data.feedName == 'urgents') {
      var rList28419 = opt_data.reports;
      var rListLen28419 = rList28419.length;
      for (var rIndex28419 = 0; rIndex28419 < rListLen28419; rIndex28419++) {
        var rData28419 = rList28419[rIndex28419];
        el8.template.ptdata.reports.abnormalSummary(rData28419, output);
      }
    }
  }
  output.append((! opt_data.patient.isVerified) ? '<p class="spacer el8AppColor">Note: This chart was automatically created because a match in the patient panel was not found.</p>' : '', '</div>');
  if (! opt_data.patient.isVip) {
    if (opt_data.messages) {
      output.append('<ol id="', soy.$$escapeHtml(opt_data.feedId), '-messages" class="el8HomeWrap ebs-list-unstyled">');
      var mList28433 = opt_data.messages;
      var mListLen28433 = mList28433.length;
      for (var mIndex28433 = 0; mIndex28433 < mListLen28433; mIndex28433++) {
        var mData28433 = mList28433[mIndex28433];
        if (! opt_data.useNewMessages) {
          el8.template.render.homeReqActFeedItem.messageThread(soy.$$augmentData(mData28433, {patientId: opt_data.patient.id}), output);
        }
      }
      output.append('</ol>');
    }
    if (opt_data.letters && opt_data.feedName != 'unfinishedLetters') {
      output.append('<ol class="el8HomeWrap ebs-list-unstyled">');
      var lList28443 = opt_data.letters;
      var lListLen28443 = lList28443.length;
      for (var lIndex28443 = 0; lIndex28443 < lListLen28443; lIndex28443++) {
        var lData28443 = lList28443[lIndex28443];
        el8.template.render.homeReqActFeedItem.letter({letter: lData28443, patient: opt_data.patient}, output);
      }
      output.append('</ol>');
    }
    if (opt_data.letterReceipts) {
      output.append('<ol class="el8HomeWrap ebs-list-unstyled">');
      var lrList28452 = opt_data.letterReceipts;
      var lrListLen28452 = lrList28452.length;
      for (var lrIndex28452 = 0; lrIndex28452 < lrListLen28452; lrIndex28452++) {
        var lrData28452 = lrList28452[lrIndex28452];
        el8.template.render.homeReqActFeedItem.letterReceipt({item: lrData28452, patient: opt_data.patient}, output);
      }
      output.append('</ol>');
    }
    if (opt_data.reminderNotifications) {
      output.append('<ol class="el8HomeWrap ebs-list-unstyled">');
      var rnList28461 = opt_data.reminderNotifications;
      var rnListLen28461 = rnList28461.length;
      for (var rnIndex28461 = 0; rnIndex28461 < rnListLen28461; rnIndex28461++) {
        var rnData28461 = rnList28461[rnIndex28461];
        el8.template.render.homeReqActFeedItem.documentReminderNotification({notification: rnData28461, patient: opt_data.patient}, output);
      }
      output.append('</ol>');
    }
    if (opt_data.unreadLetterNotifications) {
      output.append('<ol class="el8HomeWrap ebs-list-unstyled">');
      var lrList28470 = opt_data.unreadLetterNotifications;
      var lrListLen28470 = lrList28470.length;
      for (var lrIndex28470 = 0; lrIndex28470 < lrListLen28470; lrIndex28470++) {
        var lrData28470 = lrList28470[lrIndex28470];
        el8.template.render.homeReqActFeedItem.unreadLetterNotification({unreadLetterNotification: lrData28470, letter: lrData28470.letter, patient: opt_data.patient}, output);
      }
      output.append('</ol>');
    }
    if (opt_data.collaboratorNotifications) {
      output.append('<ol class="el8HomeWrap ebs-list-unstyled">');
      var nList28480 = opt_data.collaboratorNotifications;
      var nListLen28480 = nList28480.length;
      for (var nIndex28480 = 0; nIndex28480 < nListLen28480; nIndex28480++) {
        var nData28480 = nList28480[nIndex28480];
        el8.template.render.homeReqActFeedItem.plrCollaboratorNotification({notification: nData28480, patient: opt_data.patient}, output);
      }
      output.append('</ol>');
    }
    if (opt_data.directMessages) {
      output.append('<ol class="el8HomeWrap ebs-list-unstyled">');
      var msgList28489 = opt_data.directMessages;
      var msgListLen28489 = msgList28489.length;
      for (var msgIndex28489 = 0; msgIndex28489 < msgListLen28489; msgIndex28489++) {
        var msgData28489 = msgList28489[msgIndex28489];
        el8.template.render.homeReqActFeedItem.directMessage({item: msgData28489, patient: opt_data.patient}, output);
      }
      output.append('</ol>');
    }
  }
  output.append('</li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.homeReqActFeedItem.rxRefillRequestNoPatient = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItem el8FeedItemHover"><div class="el8FeedItemDate">', (soy.$$escapeHtml(opt_data.item.received_time)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.item.received_time)) : ''), '<div class="el8FeedItemIconRx"></div></div><div class="el8FeedItemContainer"><div class="el8FeedItemActionContainer">');
  el8.template.button.feedButtonList({buttons: opt_data.buttonsInfo, feedItemId: opt_data.feedItemId}, output);
  output.append('</div><p><span class="el8NewChartItem">New</span>', soy.$$escapeHtml(opt_data.item.requested_patient.full_name), '<span class="el8Indent el8AppColor">(', soy.$$escapeHtml(opt_data.item.requested_patient.sex), ')</span>', (opt_data.item.requested_patient.dob) ? '<span class="el8Indent el8AppColor">D.O.B.: ' + soy.$$escapeHtml(opt_data.item.requested_patient.dob) + '</span>' : '', '</p><p class="spacer el8AppColor">Note: This chart was automatically created because a match in the patient panel was not found.</p><p class="el8AppColor">[+1 Rx refill request]</p></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.homeReqActFeedItem.messageThread = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="message-wrapper el8PracticeHomeWrap el8FeedItemHover" data-patient-id="', soy.$$escapeHtml(opt_data.patientId), '"><div class="el8FeedItemDate"><div class="el8FeedItemIconMessage"></div></div><div class="el8FeedItemContainer"><div class="el8FeedItemActionContainer">');
  el8.template.button.feedButtonList({buttons: opt_data.buttonsInfo, feedItemId: opt_data.feedItemId}, output);
  output.append('</div>');
  el8.template.render.messageThreadContent.content(opt_data, output);
  if (opt_data.signOffUser) {
    el8.template.render.signOff.summary(soy.$$augmentData(opt_data, {signUserName: opt_data.signOffUser}), output);
  } else {
    output.append((! el8Globals.READ_ONLY) ? '<div id="threadReplyTrigger_' + soy.$$escapeHtml(opt_data.id) + '" class="threadReplyTrigger el8FieldTrigger lgFont" _fid="' + soy.$$escapeHtml(opt_data.feedItemId) + '">Reply...</div><div class="threadPane_' + soy.$$escapeHtml(opt_data.id) + '"></div>' : '');
  }
  output.append('</div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.homeReqActFeedItem.unassignedEmail = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItem el8FeedItemHover"><div class="el8FeedItemDate">', (soy.$$escapeHtml(opt_data.item.receivedTime)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.item.receivedTime)) : ''), '<div class="el8FeedItemIconEmail"></div></div><div class="el8FeedItemContainer"><div class="el8FeedItemActionContainer">');
  el8.template.button.feedButtonList({buttons: opt_data.buttonsInfo, feedItemId: opt_data.feedItemId}, output);
  output.append('</div>', (opt_data.item.emailType == 'CHART') ? '<div class="noteHeader">Email Note</div>' : '<div class="noteHeader">Direct Message</div>');
  el8.template.render.homeReqActFeedItem.unassignedEmailContent({item: opt_data.item}, output);
  output.append('</div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.homeReqActFeedItem.unassignedEmailContent = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<p class="el8Preserve">', soy.$$escapeHtml(opt_data.item.content), '</p><div class="spacer5"></div>');
  if (opt_data.item.attachments.length > 0) {
    output.append('<p class="el8AppColor">Attachments to be filed:</p><ol class="ebs-list-unstyled">');
    var aList28567 = opt_data.item.attachments;
    var aListLen28567 = aList28567.length;
    for (var aIndex28567 = 0; aIndex28567 < aListLen28567; aIndex28567++) {
      var aData28567 = aList28567[aIndex28567];
      output.append((aData28567 != opt_data.item.ccdaContentFileName) ? '<li class="el8BulletText">' + soy.$$escapeHtml(aData28567) + '</li>' : '');
    }
    output.append((opt_data.item.ccdaContentFileName) ? '<li class="el8BulletText">Patient Summary C-CDA</li>' : '', '</ol>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.homeReqActFeedItem.summary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.modelCounts.length > 1 || opt_data.modelCounts[0].count > 1 || opt_data.feedName == 'urgents' || opt_data.feedName == 'reports' || opt_data.feedName == 'unfinishedOrders' || opt_data.vip) {
    output.append('[');
    var dictList28582 = opt_data.modelCounts;
    var dictListLen28582 = dictList28582.length;
    for (var dictIndex28582 = 0; dictIndex28582 < dictListLen28582; dictIndex28582++) {
      var dictData28582 = dictList28582[dictIndex28582];
      output.append((! (dictIndex28582 == 0)) ? ', ' : '', soy.$$escapeHtml(dictData28582.count), ' ');
      el8.template.render.homeReqActFeedItem.bucketName({feedName: opt_data.feedName, mClass: dictData28582.modelClass, count: dictData28582.count}, output);
    }
    output.append(']');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.homeReqActFeedItem.bucketName = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  switch (opt_data.mClass) {
    case 'CardiacReport':
      output.append('cardiac report');
      break;
    case 'ConsultationReport':
      output.append('consultation report');
      break;
    case 'DenyCancelMedOrder':
      output.append('eRx unable to cancel');
      break;
    case 'HospitalReport':
      output.append('hospital report');
      break;
    case 'ImagingReport':
      output.append('imaging report');
      break;
    case 'LabReport':
      output.append('lab report');
      break;
    case 'LegalReport':
      output.append('legal report');
      break;
    case 'MiscReport':
      output.append('misc report');
      break;
    case 'MedOrder':
      output.append((opt_data.feedName == 'urgents') ? 'failed eRx' : 'Rx');
      break;
    case 'Letter':
      output.append((opt_data.feedName == 'urgents') ? 'failed fax' : 'letter');
      break;
    case 'MessageThread':
      output.append('msg');
      break;
    case 'Note':
      output.append((opt_data.feedName == 'urgents') ? 'failed bill' : 'note');
      break;
    case 'RxRefillRequest':
      output.append('eRx refill request');
      break;
    case 'PharmacyPrescriptionRequest':
      output.append('eRx change request');
      break;
    case 'LetterReceipt':
      output.append('incoming letter');
      break;
    case 'ReferralOrder':
      output.append('referral');
      break;
    case 'ImagingOrder':
      output.append('imaging order');
      break;
    case 'CardiacOrder':
      output.append('cardiac order');
      break;
    case 'SleepOrder':
      output.append('<!-- Sleep to Generic order UI reskin -->', (el8Globals.FEATURES.GenericOrder) ? 'order' : 'sleep order');
      break;
    case 'PulmonaryOrder':
      output.append('pulmonary order');
      break;
    case 'LabOrder':
      output.append((opt_data.feedName == 'urgents') ? 'failed lab order' : 'lab order');
      break;
    case 'IncomingDirectMessage':
      output.append('direct message');
      break;
    default:
      output.append('item');
  }
  output.append((opt_data.count > 1 && opt_data.mClass != 'DenyCancelMedOrder') ? 's' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.homeReqActFeedItem.letter = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="letter-item el8PracticeHomeWrap el8FeedItemHover" data-patient-id="', soy.$$escapeHtml(opt_data.patient.id), '" _id="', soy.$$escapeHtml(opt_data.letter.id), '"><div class="el8FeedItemContainer"><div class="el8LetterContainer"><div class="el8FeedItemActionContainer">');
  el8.template.button.feedButtonList({buttons: opt_data.letter.buttonsInfo, feedItemId: opt_data.letter.feedItemId}, output);
  output.append('</div><div class="el8FeedIconContainer">');
  el8.template.ptdata.letters.feedIcon(opt_data.letter, output);
  el8.template.ptdata.letters.letterMetadataCounts(opt_data.letter, output);
  output.append('</div>');
  el8.template.ptdata.letters.signedSummary(soy.$$augmentData(opt_data, {noAttachmentLinks: true, noHighlight: true}), output);
  output.append((opt_data.letter.withPlrInvite) ? '<p class="spacer el8AppColor">Note: You have also added the recipient to the patient\'s care team.</p>' : '', '</div>');
  el8.template.ptdata.letters.secondarySection(opt_data, output);
  output.append('</div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.homeReqActFeedItem.letterReceipt = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="letter-receipt-item el8PracticeHomeWrap el8FeedItemHover" data-patient-id="', soy.$$escapeHtml(opt_data.patient.id), '" _id="', soy.$$escapeHtml(opt_data.item.id), '">');
  if (el8Globals.PASSPORT_EMR && opt_data.item.sentDate) {
    output.append('<div class="el8FeedItemDate">');
    el8.template.render.chartFeedItem.feedDate({feedDate: opt_data.item.sentDate}, output);
    output.append('</div>');
  }
  output.append('<div class="el8FeedItemContainer"><div class="el8LetterContainer"><div class="el8FeedItemActionContainer">');
  el8.template.button.feedButtonList({buttons: opt_data.item.buttonsInfo, feedItemId: opt_data.item.feedItemId}, output);
  output.append('</div><div class="el8FeedIconContainer">');
  el8.template.ptdata.letterReceipts.feedIcon(opt_data.item, output);
  el8.template.ptdata.letterReceipts.metadataCounts(opt_data.item, output);
  output.append('</div>');
  el8.template.ptdata.letterReceipts.summary(opt_data.item, output);
  output.append((opt_data.item.withPlrInvite) ? '<p class="spacer el8AppColor">Note: You have been added to the patient\'s care team by request of the sender.</p>' : '', '</div>');
  el8.template.ptdata.letterReceipts.secondarySection(opt_data.item, output);
  output.append('</div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.homeReqActFeedItem.documentReminderNotification = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="document-reminder-notification-item el8PracticeHomeWrap el8FeedItemHover" data-patient-id="', soy.$$escapeHtml(opt_data.patient.id), '" data-id="', soy.$$escapeHtml(opt_data.notification.id), '"><div class="el8FeedItemContainerNoBorder"><div class="el8LetterContainer"><div class="el8FeedItemActionContainer">');
  el8.template.button.feedButtonList({buttons: opt_data.notification.buttonsInfo, feedItemId: opt_data.notification.feedItemId}, output);
  output.append('</div><div class="el8FeedIconContainer"><div class="el8FeedItemIconLetterNotification"></div></div><div class="el8LetterHeaderWrap"><p class="el8333 el8SingleLineText"><span class="el8Bold">', (soy.$$escapeHtml(opt_data.notification.reminder.forDocumentOrderType)? soy.$$escapeHtml(opt_data.notification.reminder.forDocumentOrderType).capitalize() : ''), ' Order Reminder </span></p><p>');
  el8.template.ptdata.model.order.displayTestNames({testNames: opt_data.notification.reminder.order.testNames}, output);
  output.append('</p><p>');
  el8.template.ptdata.model.order.orderNoteExtraInfo({followUpMethod: opt_data.notification.reminder.order.followUpMethod, dateForTest: opt_data.notification.reminder.order.dateForTest, noParens: true}, output);
  output.append('</p></div></div></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.homeReqActFeedItem.unreadLetterNotification = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="unread-letter-notification-item el8PracticeHomeWrap el8FeedItemHover" data-patient-id="', soy.$$escapeHtml(opt_data.patient.id), '" _id="', soy.$$escapeHtml(opt_data.unreadLetterNotification.id), '"><div class="el8FeedItemContainer"><div class="el8LetterContainer"><div class="el8FeedItemActionContainer">');
  el8.template.button.feedButtonList({buttons: opt_data.unreadLetterNotification.buttonsInfo, feedItemId: opt_data.unreadLetterNotification.feedItemId}, output);
  output.append('</div><div class="el8FeedIconContainer">');
  el8.template.appchart.letters.unreadAlertNotification.feedIcon({isSendToPatient: opt_data.letter.isSendToPatient, isReferralLetter: opt_data.letter.isReferralLetter}, output);
  el8.template.ptdata.letters.letterMetadataCounts(opt_data.letter, output);
  output.append('</div>');
  el8.template.appchart.letters.unreadAlertNotification.homeFeedItem(soy.$$augmentData(opt_data, {noAttachmentLinks: true, noHighlight: true}), output);
  output.append('</div></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.homeReqActFeedItem.directMessage = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="direct-message-item el8PracticeHomeWrap el8FeedItemHover" data-patient-id="', soy.$$escapeHtml(opt_data.patient.id), '" _id="', soy.$$escapeHtml(opt_data.item.id), '"><div class="el8FeedItemContainer"><div class="el8LetterContainer"><div class="el8FeedItemActionContainer">');
  el8.template.button.feedButtonList({buttons: opt_data.item.buttonsInfo, feedItemId: opt_data.item.feedItemId}, output);
  output.append('</div><div class="el8FeedIconContainer">');
  el8.template.ptdata.letterReceipts.feedIcon(opt_data.item, output);
  output.append('</div><div class="el8LetterHeaderWrap"><p class="el8333">From: <span class="el8Bold">', soy.$$escapeHtml(opt_data.item.fromAddress), '</span></p>', (opt_data.item.subject) ? '<p class="el8SingleLineText"><span class="el8333">Re: ' + soy.$$escapeHtml(opt_data.item.subject) + '</span></p>' : '', '</div></div></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.homeReqActFeedItem.plrCollaboratorNotification = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="plr-notification-item el8PracticeHomeWrap el8FeedItemHover" data-patient-id="', soy.$$escapeHtml(opt_data.patient.id), '" data-id="', soy.$$escapeHtml(opt_data.notification.id), '"><div class="el8FeedItemContainer padt0"><div class="el8LetterContainer"><div class="el8FeedItemActionContainer">');
  el8.template.button.feedButtonList({buttons: opt_data.notification.buttonsInfo, feedItemId: opt_data.notification.feedItemId}, output);
  output.append('</div><div class="el8FeedIconContainer">', (opt_data.notification.isCareTeamRelated) ? '<div class="el8FeedItemPLR4Everyone"></div>' : '<div class="el8ChartFeedIconBreakSeal"></div>', '</div><div class="el8LetterHeaderWrap"><p class="el8AppColor">');
  el8.template.ptdata.plrCollaboratorNotifications.summary(opt_data.notification, output);
  output.append('</p><p class="el8999">');
  el8.template.ptdata.plrCollaboratorNotifications.displayEventType(opt_data.notification, output);
  output.append('</p></div></div></div></li>');
  if (!opt_sb) return output.toString();
};
